import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n"; // 引入 i18n 初始化文件

if (typeof window !== "undefined") {
  const isLocalDevHost =
    window.location?.hostname === "localhost" ||
    window.location?.hostname === "127.0.0.1";

  if (isLocalDevHost) {
    window.__lukkeyDisableClarity = true;

    try {
      const clarityScripts = Array.from(
        document.querySelectorAll(
          'script#lukkey-clarity-script, script[src*="clarity.ms/tag"]'
        )
      );
      clarityScripts.forEach((script) => script.parentNode?.removeChild(script));
    } catch {}

    try {
      delete window.clarity;
    } catch {
      window.clarity = undefined;
    }

    const ignoredDevRejectionMessages = new Set([
      "Response not successful: Received status code 400",
      "Could not establish connection. Receiving end does not exist.",
    ]);

    window.addEventListener("unhandledrejection", (event) => {
      const reason = event?.reason;
      const message =
        typeof reason === "string"
          ? reason
          : typeof reason?.message === "string"
            ? reason.message
            : "";

      if (!ignoredDevRejectionMessages.has(message)) return;

      // Ignore browser-extension / injected-script noise in local CRA dev overlay.
      event.preventDefault();
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
